import { defaultAxiosConfig } from 'module/api/http-client';
import { addHopIdToHeader } from 'module/authentication/utils/hop-id';
import { logout } from 'module/authentication/utils/logout';
import { logger } from 'module/logger';
import axiosStatic, {
  AxiosError,
  AxiosInstance,
  InternalAxiosRequestConfig,
} from 'axios';
import { Observable, of } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';

const withCustomHeader = (
  header: Record<string, string>,
  configuration = defaultAxiosConfig,
): InternalAxiosRequestConfig => ({
  ...configuration,
  headers: configuration.headers.set(header),
});

const injectHopId = (configuration: InternalAxiosRequestConfig) =>
  Promise.resolve(withCustomHeader(addHopIdToHeader(), configuration));

const apiKeyHeaderKey = 'api-key';
const injectApiKey = (configuration: InternalAxiosRequestConfig<any>) => {
  const apiKey = JSON.parse(localStorage.getItem('__api_key') ?? '[]')?.[1];

  if (apiKey == null) {
    return Promise.resolve(configuration);
  }

  return Promise.resolve(
    withCustomHeader(
      { [apiKeyHeaderKey]: apiKey },
      { ...configuration, withCredentials: false },
    ),
  );

  // return Promise.resolve(configuration);
};

enum ApiErrorCode {
  InvalidKey = 'INVALID_KEY',
  NotAuthorized = 'NOT_AUTHORIZED',
}

enum ApiStatusCode {
  NotAuthorized = 401,
  TooManyRequests = 429,
}

export const axiosInstance = (): Observable<AxiosInstance> =>
  of([1]).pipe(
    map(() => axiosStatic.create(defaultAxiosConfig)),
    tap((client) => client.interceptors.request.use(injectHopId)),
    tap((client) => client.interceptors.request.use(injectApiKey)),
    tap((client) =>
      client.interceptors.response.use(
        (response) => response,
        (error: AxiosError<any>) => {
          if (
            error.response?.status === ApiStatusCode.NotAuthorized ||
            error.response?.data?.errors?.[0]?.errorCode ===
              ApiErrorCode.NotAuthorized ||
            error.response?.data?.[0]?.errorCode === ApiErrorCode.NotAuthorized
          ) {
            logger.error('response failed with 401, logging out', { error });
            logout('/login');
            // if (!EXCLUDE_LOGOUT_PATHS.includes(window.location.pathname)) {
            // }
          } else if (error.response?.status === ApiStatusCode.TooManyRequests) {
            // const retryAt = error.response?.headers['x-retry-after'];
            // toastService({
            //   title: 'Too many requests!',
            //   message: `You have exceeded the request limit.${
            //     retryAt ? ` Please try again in ${format('m', retryAt)}.` : ''
            //   }`,
            //   duration: 10,
            // }).error();
          }

          return Promise.reject(error);
        },
      ),
    ),
    shareReplay(1),
  );
